/* eslint-disable no-unused-vars */
import { PropertyFilter } from '@src/v3/interfaces/utils/http';

export interface ListingsFilterProps {
  triggerButton?: React.ReactNode;
  applyFilters: (filters: PropertyFilter) => void;
  resetFilters: () => void;
}

export enum FilterTypeEnum {
  PRICE = 'price',
  ROOMS = 'rooms',
  AMENITIES = 'amenities',
  SIZE = 'size',
  SORT = 'sort',
  NULL = 'null',
}
